import FJMobileFaceSwapThird from './FJMobileFaceSwapThird';
import { useCallback } from 'react';
import useLocalStore from '../../../hooks/useLocalStore';
import { useDispatch, useSelector } from 'react-redux';
import { setSliceMobileStep } from '../../../redux/slices/FJSliceFaceSwap';
import FJActionFaceSwap from '../../../redux/action/FJActionFaceSwap';

const FJMobileFaceSwapThirdContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);

    const mobileStep = useSelector(state => state.faceSwap.mobileStep);
    const originUploadImageInfo = useSelector(state => state.faceSwap.originUploadImageInfo);
    const targetUploadImageInfo = useSelector(state => state.faceSwap.targetUploadImageInfo);
    const targetCurLoadName = useSelector(state => state.faceSwap.targetCurLoadName);

    const gotoBack = useCallback(() => {
        dispatch(setSliceMobileStep(1));
    }, [dispatch]);

    const _onUploadTargetImage = useCallback(
        (file, callback) => {
            dispatch(FJActionFaceSwap.uploadTargetImageAction(file, callback));
        },
        [dispatch],
    );
    const _onTargetTryThose = useCallback(
        (item, callback) => {
            dispatch(FJActionFaceSwap.uploadTargetTryThoseImageAction(item, callback));
        },
        [dispatch],
    );
    const _onGenerate = useCallback(() => {
        dispatch(FJActionFaceSwap.generateAction());
    }, [dispatch]);

    return (
        <FJMobileFaceSwapThird
            active={mobileStep === 2}
            originUploadImageInfo={originUploadImageInfo}
            gotoBack={gotoBack}
            onUploadTargetImage={_onUploadTargetImage}
            onTargetTryThose={_onTargetTryThose}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            isProjectLoading={isProjectLoading}
            onGenerate={_onGenerate}
            creditNumber={creditNumber}
            targetUploadImageInfo={targetUploadImageInfo}
            targetCurLoadName={targetCurLoadName}
        />
    );
};
export default FJMobileFaceSwapThirdContainer;
